import { useCallback } from "react";
import { apiFetch } from "@/lib/api-client";

interface Contact {
  id: string;
  taxId: string;
  name: string;
  defaultExpenseAccountId: string | null;
  defaultRevenueAccountId: string | null;
}

export function useContacts() {
  const lookupByTaxIds = useCallback(
    async (taxIds: string[]): Promise<Record<string, Contact>> => {
      if (taxIds.length === 0) return {};
      const { contacts } = await apiFetch.post<{ contacts: Record<string, Contact> }>(
        "/api/rcv/entries/contacts-lookup",
        { taxIds },
      );
      return contacts;
    },
    [],
  );

  return { lookupByTaxIds };
}
